import { useTranslation } from "react-i18next";
import "./survy-list-question.scss";
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Spin,
  Typography,
  Upload,
} from "antd";
import {
  KeyboardEvent,
  useEffect,
  useState,
} from "react";
import {
  CopyOutlined,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import FormInput from "../../../../../../components/form-input/FormInput";
import AddQuestionCourseModal from "../../../../../../components/modal/add-question-course";
import {
  DEFAULT_MAX_LENGTH_QUESTION_BANK,
  DEFAULT_TEXAREA_ROW,
  ModeQuestion,
  QuestionProgressModeClick,
  QuestionTypeEnum,
  TypeCreateQuestion,
} from "../../../../../../constants";
import {
  deleteGroupQuiz,
  getQuizById,
  importQuizEnglish,
  postCreateGroup,
  postCreateSurveyGroup,
  updateGroupQuiz,
  uploadFileMoodleQuiz,
} from "../../../../../../service/course-construct";
import {
  addQuizToQuestionBank,
  addSurveyToQuestionBank,
  addUnitQuizSurveyFormBank,
  changeOrderGroupNumberQuiz,
  changeOrderNumberQuiz,
  createMoocCourseBlockQuiz,
  createMoocCourseBlockQuizConnect,
  deleteMoocCourseBlockQuiz,
  getAllQuizBySurvey,
  getAllQuizByUnit,
} from "../../../../../../service/course-plan-managment/mooc-course-block-quiz/mooc-course-block-quiz";
import { HelpService } from "../../../../../../service/helper.service";
import { useAddLesson, useAuthStore } from "../../../../../../stores/stores";
import { Quiz, UnitQuiz } from "../../../../../../types/course-construction";
import { convertQuillToString } from "../../../../../../utils/convertQuillToString";
import { routesConfig } from "../../../../../../config/routes";
import { rectSortingStrategy } from "@dnd-kit/sortable";
import {
  ItemsDraggerMulti,
  MultipleContainers,
} from "../../../../../../components/multiple-containers/examples/MultipleContainers";
import { UniqueIdentifier } from "@dnd-kit/core";
import { useDirty } from "../../../../../../contexts/DirtyProvider";
import TextArea from "antd/es/input/TextArea";
import { saveToIndexDB } from "../../../../../page-builder/grapesjs-service";
import { FileType } from "../../../../../../utils/uploadImage";
import TextEditor from "../../../../../../components/text-editor/TextEditor";
import { useForm } from "antd/es/form/Form";
import BankQuestionsModal from "./bank-questions-modal";
import { addQuizzesFromQuestionBank } from "../../../../../../service/question-bank";
import useKeyword from "../../../../../../hooks/useKeyword";
import ListQuestionBankModal from "../../../../../library/bank-question/components/list-question-bank-modal/ListQuestionBankModal";

var indexDB = require("idbcache").default;
type Props = {
  tab: string;
  dataLessonId: number;
  setTotalQuiz?: (value: number) => void;
};

export default function SurvyListQuestion(props: Props) {
  const { t } = useTranslation();
  const onRefreshQuizBlock = useAddLesson((state) => state.onRefreshQuizBlock);
  const setModeClick = useAddLesson((state) => state.setModeClick);
  const setQuestion = useAddLesson((state) => state.setQuestion);
  const setModeQuestion = useAddLesson((state) => state.setModeQuestion);
  const modeQuestion = useAddLesson((state) => state.modeQuestion);
  const refreshQuizBlock = useAddLesson((state) => state.refreshQuizBlock);
  const typeCreateQuestion = useAddLesson((state) => state.typeCreateQuestion);
  const setTypeCreateQuestion = useAddLesson(
    (state) => state.setTypeCreateQuestion
  );
  const currentIdQuestionAdd = useAddLesson(
    (state) => state.currentIdQuestionAdd
  );

  const [form] = useForm();
  const searchParams = new URLSearchParams(location.search);
  const unitId = searchParams.get("unitId");
  const helpService = new HelpService();
  const { setDirty } = useDirty();
  const accessToken = useAuthStore((state) => state.accessToken);
  const [importLoading, setImportLoading] = useState<boolean>(false);

  const [dataFiltered, setDataFiltered] = useState<any>([]);
  const [dataClone, setDataClone] = useState<any>({});
  const [namePart, setNamePart] = useState<string>("");
  const [groupDescription, setGroupDescription] = useState<any>(null);
  const [bankCodeValue, setBankCodeValue] = useState<string>("");
  const [searchValue, setSearchValue] = useState<string>("");
  const [courseBlockGroupIdClick, setCourseBlockGroupId] = useState<number>(0);
  const [courseBlockQuestionBank, setCourseBlockQuestionBank] =
    useState<number>(0);
  const [activeTab, setActiveTab] = useState<number>(-1);
  const [idQuizToAdd, setIdQuizToAdd] = useState<number>(0);
  const [addQuestionModal, setAddQuestionModal] = useState<boolean>(false);
  const [addQuestionBankModal, setAddQuestionBankModal] =
    useState<boolean>(false);
  const [loadingQuizBlock, setLoadingQuizBlock] = useState<boolean>(false);
  const [openAddPartModal, setAddPartModal] = useState<boolean>(false);
  const [openEditPartModal, setEditPartModal] = useState<boolean>(false);
  const [editGroupId, setEditGroupId] = useState<number>(1);
  const [editGroupName, setEditGroupName] = useState<string>("");
  const [editGroupDescription, setEditGroupDescription] = useState<any>(null);
  const [isSaveModalOpen, setIsSaveModalOpen] = useState<boolean>(false);
  const [isDuplicateModalOpen, setDuplicateIsModalOpen] =
    useState<boolean>(false);
  const [questionBankId, setQuestionBankId] = useState<number>(0);
  const [itemsRender, setItemsRender] = useState<ItemsDraggerMulti>({});
  const isReturn = useKeyword("isReturn");
  const modalAction = useKeyword("action");

  const [modalMode, setModalMode] = useState<string>("");

  useEffect(() => {
    if(isReturn){
      if(modalAction === "bank-select") {
        setAddQuestionBankModal(true);
      } else {
        setAddQuestionModal(true);
      }
    }
  }, [isReturn]);

  useEffect(() => {
    if(modalAction){
      setModalMode(modalAction);
    }
  }, [modalAction]);

  useEffect(() => {
    getAllQuizByUnitId();
  }, [refreshQuizBlock]);

  useEffect(() => {
    if (modeQuestion === ModeQuestion.CREATE && dataFiltered.length > 0) {
      let currentQuestionAdd: any;
      dataFiltered.some((ele: any) => {
        currentQuestionAdd = ele.quizzes.find((x: any) => {
          return x.id === currentIdQuestionAdd;
        });
        if (currentQuestionAdd) {
          return true;
        }
        return false;
      });
      getQuizLesson({
        ...currentQuestionAdd,
        type: currentQuestionAdd?.type,
        courseBlockGroupId: currentQuestionAdd?.groupId,
      });
    }
  }, [dataFiltered]);

  const getAllQuizByUnitId = async (searchKeyWord?: string) => {
    let customUnitId = unitId;
    if (!unitId) {
      return;
    }
    if (props.dataLessonId !== 0) {
      customUnitId = JSON.stringify(props.dataLessonId);
    }
    try {
      setLoadingQuizBlock(true);

      let quizes: any;

      let bodyData = {
        id: Number(customUnitId),
        keyword: "",
      };

      if (searchKeyWord === "") {
        bodyData.keyword = searchKeyWord.trim();
      } else {
        bodyData.keyword = searchValue.trim();
      }

      setModeClick(QuestionProgressModeClick.START);

      if (location.pathname.includes(routesConfig.addLesson)) {
        setTypeCreateQuestion(TypeCreateQuestion.COURSEWARE);
        quizes = await getAllQuizByUnit(bodyData);
        indexDB.set(
          "courseBlockId",
          JSON.stringify(quizes.data[0].blockId),
          1440
        );
      }

      if (location.pathname.includes(routesConfig.addSurvey)) {
        setTypeCreateQuestion(TypeCreateQuestion.SURVEY);
        quizes = await getAllQuizBySurvey(bodyData);
      }

      const quizesDataApi = quizes.data;

      const customQuizeData = quizesDataApi.map((x: UnitQuiz) => {
        x.quizzes.forEach((y: any) => {
          y.groupId = x.groupId;
        });
        return { ...x };
      });

      const customDataFiltered = quizesDataApi.filter((quizUnit: UnitQuiz) => {
        if (!quizUnit.isBegin && !quizUnit.isEnd) {
          quizUnit.id = quizUnit.groupId;
          return quizUnit;
        }
      });

      if (quizes.data) {
        const total = quizes.data.reduce((acc: number, item: any) => {
          return acc + (item.totalQuiz || 0);
        }, 0);

        props.setTotalQuiz && props.setTotalQuiz(total);
      }
      // const containers = quizesDataApi.map((quizUnit: UnitQuiz) => {
      //   return quizUnit.groupId;
      // });

      let customItemsRender: any = {};
      let customAllIdGroup: any = [];

      quizesDataApi.forEach((quizUnit: UnitQuiz, index: number) => {
        if (!quizUnit.isBegin && !quizUnit.isEnd) {
          customAllIdGroup.push("quiz-" + quizUnit.groupId);
          let arrayQuestion: UniqueIdentifier[] = [];
          quizUnit.quizzes.forEach((item: Quiz) => {
            arrayQuestion.push(convertQuillToString(item.id));
          });
          customItemsRender = {
            ...customItemsRender,
            ["quiz-" + quizUnit.groupId]: arrayQuestion,
          };
        }
      });

      let createDataIdOpenCollapse = quizesDataApi.map((quizUnit: UnitQuiz) => {
        return JSON.stringify(quizUnit.groupId);
      });

      let orderCustomItemsRender = orderObjectKeys(
        customItemsRender,
        customAllIdGroup
      );

      setDataFiltered(customDataFiltered);
      setItemsRender(orderCustomItemsRender);
      saveToIndexDB("course-block-quiz", customDataFiltered);
    } catch (error: any) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setLoadingQuizBlock(false);
      }, 1000);
    }
  };

  const saveQuizFromBank = async (selectedRowKeys: any) => {
    const dataReq = selectedRowKeys?.map((it: any) => {
      return {
        blockQuizId: it.id,
        blockQuizGroupId: courseBlockQuestionBank,
      };
    });
    try {
      const response = await addQuizzesFromQuestionBank(dataReq);
      const { status } = response;
      if (status === 200) {
        message.success(t("Thêm câu hỏi thành công", "Thêm câu hỏi thành công"));
        setAddQuestionBankModal(false);
        getAllQuizByUnitId();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const saveQuizSurveyFromBank = async (selectedRowKeys: any) => {
    const dataReq = selectedRowKeys?.map((it: any) => {
      return {
        codeQuizBank: it.id,
        blockQuizGroupId: courseBlockQuestionBank,
      };
    });
    try {
      const response = await addUnitQuizSurveyFormBank(dataReq);
      const { status, data } = response;
      if (status === 200) {
        message.success(t("Thêm câu hỏi thành công", "Thêm câu hỏi thành công"));
        setAddQuestionBankModal(false);
        getAllQuizByUnitId();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const orderObjectKeys = (obj: any, keyOrder: any) => {
    let orderedObject: any = {};
    for (let key of keyOrder) {
      if (obj.hasOwnProperty(key)) {
        orderedObject[key] = obj[key];
      }
    }
    return orderedObject;
  };

  const getQuizLesson = async (quiz: Quiz) => {
    setModeQuestion(ModeQuestion.UPDATE);
    setModeClick(QuestionProgressModeClick.INPROGRESS);
    setQuestion(quiz);
    setAddQuestionModal(false);
    setActiveTab(quiz?.id as number);
    setCourseBlockGroupId(quiz.courseBlockGroupId);
    setDirty(true);
  };

  const handleAddQuestion = (courseBlockGroupId: number) => {
    setAddQuestionModal(true);
    setCourseBlockGroupId(courseBlockGroupId);
  };

  const handleAddQuestionFormBank = (courseBlockGroupId: number) => {
    setAddQuestionBankModal(true);
    setCourseBlockQuestionBank(courseBlockGroupId);
  };

  // Modal save question
  const showSaveModal = (id: number) => {
    setIsSaveModalOpen(true);
    setIdQuizToAdd(id);
    setBankCodeValue("");
  };

  const handleChangeText = (e: any) => {
    setBankCodeValue(e.target.value);
  };

  const handleSaveQuizToBankOk = async () => {
    if (bankCodeValue) {
      try {
        let request: any;
        if (typeCreateQuestion === TypeCreateQuestion.COURSEWARE) {
          request = await addQuizToQuestionBank(idQuizToAdd, bankCodeValue);
        }
        if (typeCreateQuestion === TypeCreateQuestion.SURVEY) {
          request = await addSurveyToQuestionBank(idQuizToAdd, bankCodeValue);
        }
        helpService.successMessage(request.data.message);
        setIsSaveModalOpen(false);
      } catch (err) {
        console.error(err);
      }
    } else {
      message.error(t("Vui lòng nhập mã câu hỏi!", "Vui lòng nhập mã câu hỏi!"));
      return Promise.reject(); // Trả về Promise.reject để ngăn không cho hộp thoại đóng
    }
  };

  // Modal duplicate question
  const handleDuplicateOk = () => {
    setDuplicateIsModalOpen(false);
    getDetailQuestion(dataClone.id);
  };

  const getDetailQuestion = async (cloneFromId: any) => {
    const quizDetail = await getQuizById(cloneFromId);
    const quizClone = quizDetail.data.body;
    quizClone.question = "Bản sao " + quizClone.question;
    quizClone.id = undefined;
    const dataReq = {
      ...quizClone,
      questionBankId: questionBankId,
    }
    createQuiz(dataReq);
  };

  const createQuiz = async (dataReq: any) => {
    try {
      if (dataReq.type === QuestionTypeEnum.CONNECT) {
        await createMoocCourseBlockQuizConnect(dataReq);
      } else {
        await createMoocCourseBlockQuiz(dataReq);
      }
      helpService.successMessage(`Tạo bản sao câu hỏi thành công!`);
      onRefreshQuizBlock();
    } catch (err: any) {
      helpService.errorMessage(err?.message || t("Tạo mới thất bại", "Tạo mới thất bại"));
      console.error(err);
    }
  };

  // Delete
  const deleteQuiz = async (id: number) => {
    try {
      await deleteMoocCourseBlockQuiz(id);
      helpService.successMessage("Xoá câu hỏi thành công!");
      setQuestion({});
      getAllQuizByUnitId();
    } catch (err) {
      console.error(err);
    }
  };
 
  const handleChildDropDown = (key: string, record: any) => {
    if (key === "1") {
      setDuplicateIsModalOpen(true);
      setDataClone(record);
    }
    if (key === "2") {
      showSaveModal(record.id);
    }
    if (key === "3") {
      Modal.confirm({
        title: `Xóa câu hỏi`,
        content: `Dữ liệu đã xóa sẽ không thể khôi phục. Bạn chắc chắn muốn xóa câu hỏi ?`,
        onOk: () => deleteQuiz(record.id),
        okText: t("Xác nhận", "Xác nhận"),
        cancelText: t("Huỷ", "Huỷ"),
        centered: true,
        okButtonProps: {
          className: "ant-btn-dangerous",
        },
        icon: <WarningOutlined style={{ color: "#FF4D4F" }} />,
        footer: (_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        ),
      });
    }
  };

  const handleEnterSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getAllQuizByUnitId();
    }
  };

  const closeAddPartModal = () => {
    setNamePart("");
    setGroupDescription(null);
    form.resetFields();
    setAddPartModal(false);
    setEditPartModal(false);
  };

  const onChangeName = (e: any) => {
    if (openEditPartModal) {
      setEditGroupName(e.target.value);
    } else {
      setNamePart(e.target.value);
    }
  };

  const handleChangeDescription = (e: any) => {
    if (openEditPartModal) {
      setEditGroupDescription(e);
    } else {
      setGroupDescription(e);
    }
  };

  const handleSubmit = async () => {
    if (openEditPartModal) {
      if (editGroupName !== "") {
        let reqData = {
          title: editGroupName,
          description: editGroupDescription,
        };
        await updateGroupQuiz(editGroupId, reqData).then((res) => {
          closeAddPartModal();
          getAllQuizByUnitId();
          message.success(t("Sửa phần thành công!", "Sửa phần thành công!"));
        });
      } else {
        helpService.errorMessage("Chưa nhập tên phần");
      }
    } else {
      if (namePart !== "") {
        let data: any;
        if (typeCreateQuestion === TypeCreateQuestion.COURSEWARE) {
          data = {
            unitId: Number(unitId),
            title: namePart,
            orderNumber: dataFiltered.length + 1 || 1,
            description: groupDescription,
          };
          await postCreateGroup(data)
            .then((res) => {
              if (res.status === 200) {
                closeAddPartModal();
                getAllQuizByUnitId();
                message.success(t("Thêm phần thành công!", "Thêm phần thành công!"));
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
        if (typeCreateQuestion === TypeCreateQuestion.SURVEY) {
          data = {
            surveyFormId: Number(unitId),
            title: namePart,
            orderNumber: dataFiltered.length + 1 || 1,
            description: groupDescription,
          };
          await postCreateSurveyGroup(data)
            .then((res) => {
              if (res.status === 200) {
                closeAddPartModal();
                getAllQuizByUnitId();
                message.success(t("Thêm phần thành công!", "Thêm phần thành công!"));
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else {
        helpService.errorMessage("Chưa nhập tên phần");
      }
    }
  };

  const handelChangePostionParent = async (value: any, cb?: any) => {
    const newOrderParent = value.map((x: any, i: number) => {
      return { id: Number(x.replace("quiz-", "")), orderNumber: i + 1 };
    });
    const requestOrderParent = await changeOrderGroupNumberQuiz(newOrderParent);
    if (requestOrderParent.status === 200) {
      helpService.successMessage(requestOrderParent.data.message);
    } else {
      helpService.errorMessage(requestOrderParent.data.message);
    }
  };

  const handelChangePostionChild = async (value: any, cb?: any) => {
    let newOrderChild: any = [];
    Object.entries(value).forEach((key: any, i: number) => {
      newOrderChild = key[1].map((x: any, i: number) => {
        return {
          id: Number(x),
          orderNumber: i + 1,
          groupId: Number(key[0].replace("quiz-", "").replaceAll('"', "")),
        };
      });
    });
    const requestOrderChild = await changeOrderNumberQuiz(newOrderChild);
    if (requestOrderChild.status === 200) {
      helpService.successMessage(requestOrderChild.data.message);
    } else {
      helpService.errorMessage(requestOrderChild.data.message);
    }
  };

  const handleBeforeUpload = (file: FileType) => {
    const isXMLFile = file.type === "text/xml";
    if (!isXMLFile) {
      helpService.errorMessage("Bạn phải tải lên file XML !");
    }
    return isXMLFile;
  };

  const handleCustomRequestUpload = async (options: any) => {
    const file = options.file;
    if (file.type === "text/xml") {
      const formData = new FormData();
      formData.append("unitId", JSON.stringify(Number(unitId)));
      formData.append("groupId", JSON.stringify(editGroupId));
      formData.append("xmlFile", file);
      await uploadFileMoodleQuiz(formData).then((res) => {
        if (res.status === 200) {
          helpService.successMessage(res.data.message);
          onRefreshQuizBlock();
        }
      });
    }
  };

  const FullPageLoading = () => {
  const { t } = useTranslation();
    return (
      <div
        style={{
          top: 0,
          left: 0,
          zIndex: 2,
          width: "100vw",
          height: "100vh",
          display: "flex",
          position: "fixed",
          pointerEvents: "all",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
        }}
      >
        <Spin size="large" className="mr-2" />
        <span>{t("Đang tải file", "Đang tải file")}</span>
      </div>
    );
  };

  useEffect(() => {
    if (location.pathname.includes("content-course-detail")) {
      document.body.classList.add("add-lesson-index");
    }

    return () => {
      document.body.classList.remove("add-lesson-index");
    };
  }, [location.pathname]);

  return (
    <>
      {importLoading && <FullPageLoading />}
      <div className="end-question-lesson">
        <div className="end-question-lesson__header">
          <Row gutter={[{ xs: 8, xl: 8, md: 8 }, 8]} className="mt-2">
            <Col
              xl={{ span: 24 }}
              md={{ span: 24 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <FormInput
                placeholder={t("Tìm câu hỏi", "Tìm câu hỏi")}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  if (e.target.value === "") {
                    getAllQuizByUnitId(e.target.value);
                  }
                }}
                onKeyPress={handleEnterSearch}
                afterPrefixIcon={
                  <SearchOutlined
                    onClick={() => {
                      getAllQuizByUnitId();
                    }}
                  />
                }
              />
            </Col>
          </Row>
        </div>
        <section className="end-question-lesson__body">
          <Spin spinning={loadingQuizBlock}>
            <div className="dragger-multiple-containers multiple-quizes">
              <MultipleContainers
                collapsible={true}
                activeQuestion={activeTab}
                strategy={rectSortingStrategy}
                vertical
                modalMode={modalMode}
                setModalMode={setModalMode}
                titleButton={t("Chọn từ ngân hàng câu hỏi", "Chọn từ ngân hàng câu hỏi")}
                dataItemsRender={itemsRender}
                dataBase={dataFiltered}
                handelChangePostionParent={handelChangePostionParent}
                handelChangePostionChild={handelChangePostionChild}
                handle={true}
                trashable={true}
                handleAddQuestionFromBank={handleAddQuestionFormBank}
                handleAddGroupQuestion={handleAddQuestion}
                handleClickChild={(id) => {
                  let record: any = {};
                  dataFiltered.map((x: UnitQuiz) => {
                    x.quizzes.map((y: Quiz) => {
                      if (y.id === id) {
                        record = y;
                      }
                    });
                  });
                  getQuizLesson({
                    ...record,
                    type: record.type,
                    courseBlockGroupId: record.groupId,
                  });
                }}
                handleClickDropDownChild={(key, id) => {
                  let record: any = {};
                  dataFiltered.map((x: UnitQuiz) => {
                    x.quizzes.map((y: Quiz) => {
                      if (y.id === id) {
                        record = y;
                      }
                    });
                  });
                  handleChildDropDown(key, record);
                }}
                handleEditNameGroup={(id) => {
                  setEditGroupId(Number(id.split("-")[1]));
                  setEditPartModal(true);
                  const groupDetail = dataFiltered.find(
                    (item: any) => item.groupId === Number(id.split("-")[1])
                  );
                  setEditGroupName(groupDetail?.title);
                  setEditGroupDescription(groupDetail.description);
                  form.setFieldsValue({
                    name: groupDetail?.title,
                    description: groupDetail.description,
                  });
                }}
                handleDeleteGroup={(id) => {
                  Modal.confirm({
                    title: `Xóa phần`,
                    content: `Dữ liệu đã xóa sẽ không thể khôi phục. Bạn chắc chắn muốn xóa phần này ?`,
                    onOk: () => {
                      const respone = deleteGroupQuiz(Number(id.split("-")[1]));
                      respone
                        .then((res) => {
                          getAllQuizByUnitId();
                        })
                        .catch((error) => {});
                    },
                    okText: t("Xác nhận", "Xác nhận"),
                    cancelText: t("Huỷ", "Huỷ"),
                    centered: true,
                    okButtonProps: {
                      className: "ant-btn-dangerous",
                    },
                    icon: <WarningOutlined style={{ color: "#FF4D4F" }} />,
                    footer: (_, { OkBtn, CancelBtn }) => (
                      <>
                        <CancelBtn />
                        <OkBtn />
                      </>
                    ),
                  });
                }}
                handleAddGroupId={(id) => {
                  setEditGroupId(id);
                }}
                uploadMoodle={{
                  showUploadList: false,
                  accept: ".xml",
                  beforeUpload(file) {
                    handleBeforeUpload(file);
                  },
                  customRequest(options) {
                    handleCustomRequestUpload(options);
                  },
                }}
              />
            </div>
          </Spin>
        </section>
        <Button
          className="cursor-pointer add-question p-1 add-part"
          onClick={() => {
            setAddPartModal(true);
          }}
        >
          <PlusOutlined className="mr-2" />
          {t("Thêm phần", "Thêm phần")}
        </Button>
        {/* <Upload
          name="file"
          accept=".pdf,.doc,.docx"
          disabled={importLoading}
          action={BASE_URL_V2 + `/mooc-course-block-quiz/upload-file`}
          headers={{
            Authorization: "Bearer " + accessToken,
          }}
          className={`cursor-pointer add-question p-1 import-file ${
            importLoading ? "inactive" : "active"
          }  `}
          showUploadList={false}
          onChange={async (info) => {
            setImportLoading(true);
            if (info.file.status === "done") {
              const file = info.file.originFileObj;

              if (!file) {
                console.error("Không tìm thấy file");
                return;
              }

              const formData = new FormData();
              formData.append("file", file);
              formData.append("unitId", String(unitId));

              try {
                const res = await importQuizEnglish(formData);
                if (res.status === 200) {
                  message.success(t("Tải lên thành công!", "Tải lên thành công!"));
                  getAllQuizByUnitId();
                  setImportLoading(false);
                }
              } catch (err) {
                setImportLoading(false);
                message.error(t("Tải lên thất bại, vui lòng thử lại!", "Tải lên thất bại, vui lòng thử lại!"));
                console.error(err);
              } finally {
                setImportLoading(false);
              }
            } else if (info.file.status === "error") {
              setImportLoading(false);
              message.error(t("Tải lên thất bại, vui lòng thử lại!", "Tải lên thất bại, vui lòng thử lại!"));
              console.error(`Tải lên thất bại: ${info.file.name}`);
            }
          }}
          beforeUpload={(file) => {
            const isAllowedType =
              file.type === "application/pdf" ||
              file.type === "application/msword" || // .doc
              file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // .docx

            if (!isAllowedType) {
              message.error(t("Chỉ tải lên file PDF hoặc Word (.doc, .docx)", "Chỉ tải lên file PDF hoặc Word (.doc, .docx)"));
              return Upload.LIST_IGNORE;
            }
            return true;
          }}
        >
          <div className="input-upload">
            <UploadOutlined className="mr-2" /> {t("Tải file", "Tải file")}
          </div>
        </Upload> */}
      </div>
      <Modal
        title={openEditPartModal ? `Sửa phần` : `Thêm phần`}
        open={openEditPartModal ? openEditPartModal : openAddPartModal}
        okText={openEditPartModal ? `Sửa` : `Thêm`}
        cancelText={t("Hủy", "Hủy")}
        onOk={handleSubmit}
        onCancel={closeAddPartModal}
        width={690}
        className="create-and-edit-modal"
      >
        <Form
          form={form}
          initialValues={{ name: "", description: "" }}
          className="form-input-group"
        >
          <div className="input-part-name">
            <Typography.Text>{t("Tên phần", "Tên phần")}</Typography.Text>
            <Form.Item required={true} name="name">
              <Input onChange={onChangeName} />
            </Form.Item>
          </div>

          <div className="input-description">
            <Typography.Text>{t("Mô tả", "Mô tả")}</Typography.Text>
            <Form.Item name="description">
              <TextEditor onChange={handleChangeDescription} />
            </Form.Item>
          </div>
        </Form>
      </Modal>

      <AddQuestionCourseModal
        modalMode={modalMode}
        getAllQuizByUnitId={getAllQuizByUnitId}
        courseBlockGroupIdClick={courseBlockGroupIdClick}
        open={addQuestionModal}
        title={`${modalMode === "upload" ? t("Tải file .xml", "Tải file .xml") : t("Thêm câu hỏi", "Thêm câu hỏi")}`}
        closeIcon={true}
        okText={t("Xác nhận", "Xác nhận")}
        cancelText={t("Huỷ", "Huỷ")}
        icon={null}
        closeModal={() => setAddQuestionModal(false)}
      />
      <BankQuestionsModal
        modalMode="bank-select"
        courseBlockGroupIdClick={courseBlockGroupIdClick}
        open={addQuestionBankModal}
        onOk={
          typeCreateQuestion === TypeCreateQuestion.SURVEY
            ? saveQuizSurveyFromBank
            : saveQuizFromBank
        }
        onClose={() => {
          setAddQuestionBankModal(false);
        }}
      />
      <Modal
        className="save-modal"
        title={t("Lưu vào ngân hàng câu hỏi", "Lưu vào ngân hàng câu hỏi")}
        open={isSaveModalOpen}
        onOk={handleSaveQuizToBankOk}
        onCancel={() => {
          setIsSaveModalOpen(false);
        }}
        okText={t("Xác nhận", "Xác nhận")}
        cancelText={t("Hủy", "Hủy")}
      >
        <div className="save-modal-input">
          <label>{t("Mã câu hỏi:", "Mã câu hỏi:")} </label>
          <TextArea
            placeholder={t("Nhập mã vào đây", "Nhập mã vào đây")}
            maxLength={DEFAULT_MAX_LENGTH_QUESTION_BANK}
            rows={DEFAULT_TEXAREA_ROW}
            showCount
            autoSize={{ minRows: 1, maxRows: 10 }}
            onChange={handleChangeText}
            value={bankCodeValue}
          />
        </div>
      </Modal>

      <ListQuestionBankModal
        mode="duplicate"
        moveLoading={loadingQuizBlock}
        isOpenModal={isDuplicateModalOpen}
        setBankId={setQuestionBankId}
        setIsOpenModal={setDuplicateIsModalOpen}
        hanldeMoveQuizToQuestionBank={handleDuplicateOk}
      />
    </>
  );
}
